import { render, staticRenderFns } from "./LegacyFormsWorkspace.vue?vue&type=template&id=7e3d7631"
import script from "./LegacyFormsWorkspace.vue?vue&type=script&lang=js"
export * from "./LegacyFormsWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports